
const rts = {
  handleInit_fpw: 'handleInit_fpw',
}

export const fullPageWrapperInitialState = (initState) => {
  return { ...initState }
};

export const fullPageWrapperReducer = (state, action) => {

  const { type } = action

  switch (type) {

    case rts.handleInit_fpw:
      console.log('handleInit_fpw', action.fpwProps)
      return { ...state, fpwProps: action.fpwProps }

    default:
      return state;
  }
}

export const fullPageWrapperHandlers = (dispatch) => {
  return {
    handleInit_fpw: (fpwProps) => { dispatch({ type: rts.handleInit_fpw, dispatch, fpwProps }) },
  }
}

